import Portfolio from "../Entities/Portfolio";
import PageStyle from "../../Components/Enums/PageStyle";

const ForceOfNature: Portfolio = {
    path: "force-of-nature", name: "Force of Nature", pageStyle: PageStyle.Tan, pieces: [
        {
            image: "force-of-nature-01.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 1",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "force-of-nature-02.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 2",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "force-of-nature-03.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 3",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "force-of-nature-04.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 4",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "force-of-nature-06.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 6",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "force-of-nature-07.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 7",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "force-of-nature-08.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 8",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "force-of-nature-12.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 12",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "force-of-nature-13.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 13",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "force-of-nature-15.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 15",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "force-of-nature-16.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 16",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "force-of-nature-25.jpg",
            thumbAlt: "force of nature",
            title: "Force of Nature 25",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
    ],
    piecesColumns: 6,
    statement: {
        leftColumn: [
            <b>The Lotus in the Mud: A Response to the 2015 Nepal Earthquake</b>,
            "Recently, I returned to many of the beautiful, sacred places in Kathmandu that I visited before the earthquake of April 2015. I felt keenly aware as I witnessed the wounds and destruction in temples, houses, monuments, stupas, and people. I wanted to bear witness, but also to do more…to express the pain here, to give life to the idea of rebuilding, to activate hope.",
            "The visits were heart breaking and inspiring. The destruction felt brutal, uncompromising, and uncontrollable. The perceived fear among the people is palpable as the unknown is looming and threatening to an already deeply challenged community of survivors.",
            "…then there was the spark that consistently inspired and humbled. Near almost every heap of rubble, there was a grain of beauty: Flowers emerging, colorful flags, butter lamps, prayers chanted, prayer wheels turning, monkeys basking in the sun. People appeared to be navigating their lives with balance, and dignity. There is chaos and visual stimulation that can overwhelm, but it is accompanied with grace that underlies everything. The calm strength comes from true community, connection with each other, spiritual practice, and respect for \"what is.\""
        ],
        rightColumn: [
            <b>This work deals with the "Force of Nature," the incontrollable energy produced by the earth impacting rocks, mountains, buildings with undeniable force.</b>,
            "The main idea is the underlying theme of destruction and creation, the earth as a living organism in constant formation, the uncontrollable forces associated with that formation, and the reaction that moves toward balance, redemption, and human nobility."
        ]
    }
};

export default ForceOfNature;